var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_189981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14335 24.6226H6.15244C5.88867 24.6218 5.63593 24.5167 5.44942 24.3302C5.2629 24.1437 5.15777 23.8909 5.15698 23.6272V7.69985C5.15777 7.43608 5.2629 7.18334 5.44942 6.99682C5.63593 6.81031 5.88867 6.70518 6.15244 6.70439H25.0661C25.3299 6.70518 25.5826 6.81031 25.7691 6.99682C25.9557 7.18334 26.0608 7.43608 26.0616 7.69985V9.69076H9.13881C8.87504 9.69155 8.6223 9.79668 8.43578 9.98319C8.24927 10.1697 8.14414 10.4224 8.14335 10.6862V24.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14337 24.6226V25.6181C8.14416 25.8819 8.24929 26.1346 8.4358 26.3211C8.62232 26.5076 8.87506 26.6128 9.13883 26.6135H27.057C27.3208 26.6128 27.5736 26.5076 27.7601 26.3211C27.9466 26.1346 28.0517 25.8819 28.0525 25.6181V10.6862C28.0517 10.4225 27.9466 10.1697 27.7601 9.98321C27.5736 9.7967 27.3208 9.69157 27.057 9.69078H9.13883C8.87506 9.69157 8.62232 9.7967 8.4358 9.98321C8.24929 10.1697 8.14416 10.4225 8.14337 10.6862V24.6226Z",
    fill: "#59A5EE",
    stroke: "#4C5B66",
    strokeWidth: 1.40535,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0525 22.134V25.6181C28.0517 25.8819 27.9466 26.1346 27.7601 26.3211C27.5735 26.5076 27.3208 26.6128 27.057 26.6135H25.5639L23.5729 24.6226L19.0934 20.1431L20.0888 19.1476L22.5775 16.659L28.0525 22.134Z",
    fill: "#84CD4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5639 26.6135H9.13883C8.87506 26.6128 8.62232 26.5076 8.4358 26.3211C8.24929 26.1346 8.14416 25.8819 8.14337 25.6181V24.1249L15.6093 16.659L19.0934 20.1431L23.5729 24.6226L25.5639 26.6135Z",
    fill: "#A5F368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65017 24.6226H6.15244C5.88867 24.6218 5.63593 24.5167 5.44942 24.3302C5.2629 24.1437 5.15777 23.8909 5.15698 23.6272V7.69985C5.15777 7.43608 5.2629 7.18334 5.44942 6.99682C5.63593 6.81031 5.88867 6.70518 6.15244 6.70439H25.0661C25.3299 6.70518 25.5826 6.81031 25.7691 6.99682C25.9556 7.18334 26.0608 7.43608 26.0616 7.69985V8.19758",
    stroke: "#4C5B66",
    strokeWidth: 1.40535,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14337 24.1249L15.6093 16.659L19.0934 20.1431L23.5729 24.6226",
    stroke: "#4C5B66",
    strokeWidth: 0.702675,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8866 22.134L22.4116 16.659L19.9229 19.1476",
    fill: "#A5F368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8866 22.134L22.4116 16.659L19.9229 19.1476",
    stroke: "#4C5B66",
    strokeWidth: 0.702675,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_189981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.891,
    height: 23.891,
    fill: "white",
    transform: "translate(4.65924 4.71346)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6582f536cf79422fffe3d7a804a22eda.svg";
export { ForwardRef as ReactComponent };